import React from "react";
import { Layout, Typography, Row, Col, Card } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const perks = [
  {
    title: "Flexible Learning",
    description: "Access courses, challenges, and mentorship at your own pace.",
  },
  {
    title: "Exclusive Job Opportunities",
    description: "Get matched with top companies looking for AI and tech talent.",
  },
  {
    title: "Industry Certifications",
    description: "Earn certifications recognized by industry leaders.",
  },
  {
    title: "Networking & Community",
    description: "Engage with like-minded professionals and industry experts.",
  },
  {
    title: "Real-World Projects",
    description: "Gain hands-on experience with projects that mirror real industry challenges.",
  },
  {
    title: "Mentorship Programs",
    description: "Receive guidance from experts in AI, cybersecurity, and data science.",
  },
];

const Perks = () => {
  return (
    <Layout>
      <Content style={{ padding: "50px" }}>
        <Title level={2}>Perks of Joining JectHub</Title>
        <Paragraph>Discover the benefits of being part of JectHub and take your career to the next level.</Paragraph>
        <Row gutter={[16, 16]}>
          {perks.map((perk, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <Card title={perk.title} bordered={false}>
                <Paragraph>{perk.description}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </Content>
    </Layout>
  );
};

export default Perks;
